import 'core-js';
import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import { enableES5 } from 'immer';

import React from 'react';
import ReactDOM from 'react-dom';
import { createHashHistory, createMemoryHistory } from 'history';
import { Provider } from 'react-redux';
import { QueryClient, QueryClientProvider } from 'react-query';
import configureStore from './store/configureStore';
import AppContainer from './containers/App';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import Platform from './platform';
import customGA from './helpers/customGA';

Platform.initialize();

customGA.initialize();

// Immer uses Proxy object by default.
// On some devices this object could be unavailable because of ES5 environment
// https://immerjs.github.io/immer/docs/installation
enableES5();

// BrowserHistory and hashHistory don’t work smoothly on tizen
const history = Platform.getName() === 'Tizen' ? createMemoryHistory() : createHashHistory();

const queryClient = new QueryClient();

history.listen((location) => {
  customGA.trackPageView(location.pathname);
});

//For Volia inner analytics task. Yes it is a huge crutch, but we are working for Volia )
export const store = configureStore(history);

ReactDOM.render(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  <Provider store={store as any}>
    <QueryClientProvider client={queryClient}>
      <I18nextProvider i18n={i18n}>
        <AppContainer history={history} />
      </I18nextProvider>
    </QueryClientProvider>
  </Provider>,
  document.getElementById('root'),
);
